Ext.define('SA.view.ViewActionsMenuBuilder', {
    singleton: true,

    build({projectView, customItems = []}) {
        var getSeparator = () => ({xtype: 'menuseparator'});

        return {
            xtype: 'sa-menu-button',
            margin: '0 10 0 0',
            text: 'View Actions',

            menu: {
                xtype: 'menu',
                defaults: {projectView},
                items: getAllItems()
            }
        };

        function getAllItems() {
            if (customItems.length) {
                return [
                    getEditItem(),
                    getSeparator(),
                    ...customItems,
                    getSeparator(),
                    getDeleteItem()
                ];
            }

            return [
                getEditItem(),
                getSeparator(),
                getDeleteItem()
            ];
        }

        function getEditItem() {
            return {
                text: 'Edit View',
                handler: () => SA.AppController.showProjectView(projectView, 'edit')
            };
        }

        function getDeleteItem() {
            return {
                text: 'Delete View',
                handler: () => SA.AppController.deleteView(projectView)
            };
        }
    }
});